var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"purchase-btn",class:{ 'purchase-arrow': _vm.isArrow },on:{"click":function($event){$event.stopPropagation();return _vm.handleSquareBtnClick($event)}}},[_vm._v(" "+_vm._s(_vm.localizedText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }